import RemoteCareView from './views/RemoteCare'
import RoomConditionsView from './views/RoomConditions'

export default [
  {
    path: 'analytics/remotecare',
    name: 'analytics-remotecare',
    component: RemoteCareView,
  },
  {
    path: 'analytics/room',
    name: 'analytics-room',
    component: RoomConditionsView,
  }
]

